import { defineStore } from 'pinia'
import { serviceConfig } from '@h5-journey/config'

type AnyRecord = Record<string, any>

interface CityInfo extends AnyRecord {
  cityCnName: string
}

interface AppState {
  serviceConfig: typeof serviceConfig
  user: AnyRecord
  selectedCity: CityInfo | AnyRecord
  productDetail: AnyRecord
  instructions: AnyRecord
  cityIdList: CityInfo[]
  limitInfo: AnyRecord
  productCity0: CityInfo[]
  useScoreSelected: boolean
  useCouponSelected: boolean
  useBestPriceObj: AnyRecord
  sourceFlag: string
  terminalCode: string
  channelId: string
}

const setItem = (state: AnyRecord | AnyRecord[], data: AnyRecord | AnyRecord[]) => {
  for (const key in data) {
    const nextValue = (data as AnyRecord)[key]
    if (Array.isArray(nextValue)) {
      ;(state as AnyRecord)[key] = nextValue
    } else if (typeof nextValue === 'object') {
      if (!Object.keys(nextValue || {}).length) {
        ;(state as AnyRecord)[key] = {} // 如果新对象是空直接覆盖成空对象
      } else {
        ;(state as AnyRecord)[key] = {
          ...(state as AnyRecord)[key],
          ...nextValue
        } // 保证差异更新
      }
    } else {
      ;(state as AnyRecord)[key] = nextValue
    }
  }
}

export const useAppStore = defineStore('app', {
  state: (): AppState => ({
    serviceConfig: serviceConfig,
    user: {},
    selectedCity: {},
    productDetail: {},
    instructions: {},
    cityIdList: [],
    limitInfo: {},
    productCity0: [], // 国家历史记录
    useScoreSelected: true, // 积分抵现是否勾选，默认勾选
    useCouponSelected: true, // 本单优惠是否勾选，默认勾选
    useBestPriceObj: {}, // 最佳优惠券对象（带持久化）
    sourceFlag: '', // 全局渠道标识
    terminalCode: '', // 终端编码
    channelId: '' // 渠道ID
  }),
  getters: {
    getSelectedCity: (state: AppState) => {
      const cityList = state.cityIdList || []
      if (!Object.keys(state.selectedCity).length && cityList.length) {
        const localCity = sessionStorage.getItem('localCity')
        if (localCity) {
          // 当前定位城市在出发城市列表中
          const currentCity = cityList.find((c) => c.cityCnName === localCity)
          if (currentCity) {
            return {
              ...currentCity,
              cityCnName: localCity
            }
          }
        }
        // localCity 不存在或不匹配时，默认返回列表第一项
        return {
          ...cityList[0],
          cityCnName: cityList[0].cityCnName
        }
      }
      return state.selectedCity
    }
  },
  actions: {
    setSelectedCity(data: Partial<CityInfo>) {
      setItem(this.selectedCity, data)
    },
    setInstructions(data: AnyRecord) {
      setItem(this.instructions, data)
    },
    setProductDetail(data: AnyRecord) {
      setItem(this.productDetail, data)
    },
    setCityIdList(data: CityInfo[]) {
      setItem(this.cityIdList, data)
    },
    setLimitInfo(data: AnyRecord) {
      setItem(this.limitInfo, data)
    },
    setItem(data: AnyRecord) {
      setItem(this, data)
    },
    setUseScoreSelected(value: boolean) {
      this.useScoreSelected = value
    },
    setUseCouponSelected(value: boolean) {
      this.useCouponSelected = value
    },
    setBestPriceObj(data: AnyRecord) {
      setItem(this.useBestPriceObj, data)
      console.log('data------>>>', this.useBestPriceObj)
      // 直接替换引用并持久化，空对象则重置为空
      // const next = (data && Object.keys(data).length) ? { ...data } : {}
      // this.useBestPriceObj = next
      // try {
      //     sessionStorage.setItem('bestPriceObj', JSON.stringify(next))
      // } catch (e) {
      //     // ignore
      // }
    }
  }
})
